export default __webpack_public_path__ + "static/media/insurance_samples.df115900.jpg";